import { LazyLoadedStates } from "../interfaces/lazy-loaded-states.interface";

export class LazyLoadedStatesManager<T extends {base: LazyLoadedStates, [key: string]: LazyLoadedStates}>  {
    private _states: T;
    private _loadChildren: () => void
    private _children: LazyLoadedStatesManager<any>[];

    constructor(states: T, loadChildren: () => void, children: LazyLoadedStatesManager<any>[] = []) {
        this._states = states;
        this._loadChildren = loadChildren;
        this._children = children;
    }

    get statesMap() {
        return this._states;
    }

    get baseName() {
        return this._states.base.name;
    }

    generateLazyLoadedStates = () => {
        return this.getAllStates()
            .map((state) => {
                return state === this._states.base ?
                    {
                        ...state,
                        loadChildren: this._loadChildren
                    } : state
            });
    }

    generateChildrenLazyLoadedStates = () => {
        return this._children
            .map(c => c.generateLazyLoadedStates())
            .flat(1);
    }

    private getAllStates = (): LazyLoadedStates[] => {
        return Object.keys(this._states)
            .map((k) => this._states[k])
            .concat(this.getAllChildrenStates())
    }

    private getAllChildrenStates = (): LazyLoadedStates[] => {
        return this._children
            .map(c => c.getAllStates())
            .flat(1);
    }
}